export enum BaseTypes {
  session = 'session',
  policies = 'policies',
  renewals = 'renewals',
  endorsement = 'endorsement',
  sinisters = 'sinisters',
  cancellation = 'cancellation'
}
